import {
  Component,
  Inject,
  OnInit,
  PLATFORM_ID,
  ViewChild,
} from '@angular/core';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';
import { Observable, Subscription } from 'rxjs';
import { map, startWith } from 'rxjs/operators';
import { FormControl } from '@angular/forms';
import { SellService } from '@shared/services/api/sell.service';
import {
  MatAutocomplete,
  MatAutocompleteTrigger,
} from '@angular/material/autocomplete';

import {
  arrayPrecioDe,
  arrayPrecioa,
  arrayRentabilidad,
} from '@app/buy/tab-list/list/filter-properties/filter-constant';
import { Router } from '@angular/router';
import { isPlatformBrowser } from '@angular/common';
import { FilterPropertiesDataService } from '@app/@shared/services/web/filter-properties.data.service';

@Component({
  selector: 'app-home-filters',
  templateUrl: './home-filters.component.html',
  styleUrls: ['./home-filters.component.scss'],
})
export class HomeFiltersComponent implements OnInit {
  provincia: any;
  ciudad: any;
  language: any;
  country = '';
  selectedLocation = new FormControl();
  filteredOptions: Observable<any[]>;
  arrayFilterLocation: any[] = [];
  filter: any[] = [];
  provinces: Array<any> = [];
  provincesOriginal: Array<any> = [];
  propLocationName: string = null;
  propProvinceName: string = null;
  arrayLocationFilters: any[] = [];
  selectedLocationResults = '';
  locationIds: Array<any> = [];
  @ViewChild('typehead', { read: MatAutocompleteTrigger })
  autoTrigger: MatAutocompleteTrigger;
  @ViewChild(MatAutocomplete) matAutocomplete: MatAutocomplete;
  // PRECIOS
  arrayPrecioDe: any[] = arrayPrecioDe;
  arrayPrecioa: any[] = arrayPrecioa;
  arrayRentabilidad: any[] = arrayRentabilidad;
  filtrado = false;
  minSelectedPriceDefault = 0;
  maxSelectedPriceDefault = 999999999;
  minSelectedPrice: number = this.minSelectedPriceDefault;
  maxSelectedPrice: number = this.maxSelectedPriceDefault;
  minSelectedWidth: number = 3;
  maxSelectedWidth: number = 3;
  priceFilters: Array<any> = [];
  priceFilterApplied = false;
  pricefiltersString: string = null;
  // RENTABILIDAD
  ArrayProfitabilityFilters: any[] = [];
  profitabilityFilters: Array<any> = [];
  ArrayMoreFilters: any[] = [];
  minValueProfitability = 0;
  minValueProfitabilityWidth = 0;
  // ADICIONALES
  private changeLangSubscription: Subscription;
  constructor(
    private translateService: TranslateService,
    public _sellService: SellService,
    private router: Router,
    public filterPropertiesDataService: FilterPropertiesDataService,
    @Inject(PLATFORM_ID) private platform: any
  ) {}

  setCurrentLanguage(): void {
    if (this.translateService.currentLang === 'en') {
      this.language = 'en';
      this.provincia = ', Province';
      this.ciudad = ', City';
      this.country = 'Spain';
      if (
        this.minValueProfitability === 0 &&
        (this.minValueProfitabilityWidth === 6 ||
          this.minValueProfitabilityWidth === 0)
      )
        this.minValueProfitabilityWidth = 3;
    } else if (this.translateService.currentLang === 'es') {
      this.language = 'es';
      this.provincia = ', Provincia';
      this.ciudad = ', Ciudad';
      this.country = 'España';
      if (
        this.minValueProfitability === 0 &&
        (this.minValueProfitabilityWidth === 3 ||
          this.minValueProfitabilityWidth === 0)
      )
        this.minValueProfitabilityWidth = 6;
    }
  }

  ngOnInit(): void {
    if (isPlatformBrowser(this.platform)) {
      const selectPriceMin = document.getElementById('selectPriceMin') as any;
      const selectPriceMax = document.getElementById(
        'selectPriceMax'
      ) as HTMLSelectElement | null;
      const selectProfitMin = document.getElementById(
        'selectProfitMin'
      ) as HTMLSelectElement | null;

      setTimeout(() => {
        selectPriceMin.selectedIndex = 0;
        selectPriceMax.selectedIndex = 0;
        selectProfitMin.selectedIndex = 0;
      }, 200);
    }
    this.language = this.translateService.currentLang;
    this.setCurrentLanguage();
    this.changeLangSubscription = this.translateService.onLangChange.subscribe(
      (event: LangChangeEvent) => {
        this.setCurrentLanguage();
      }
    );
    this.filteredOptions = this.selectedLocation.valueChanges.pipe(
      startWith(''),
      map((value) => this._filter(value))
    );
    this.initResources();
    // this.filterPropertiesDataService.buildQueryPublications(null, true);
    this.arrayRentabilidad.forEach((element) => {
        element.selected = false;
    });
    if (this.provinces.length > 0) {
      this.provinces.forEach((prov) => {
        prov.isUnique = false;
        prov.isSelected = false;
        prov.locations.forEach((loc: any) => {
          loc.isChecked = false;
          if (loc.isChecked) {
            this.propLocationName = loc.description_filter
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
            this.locationIds.push(loc.id_location);
          }
        });
      });
    }
    this.filterPropertiesDataService.reset();
  }

  initResources(): void {
    this._sellService.getProvincesWithPublications().subscribe((data: any) => {
      this.setProvinces(data);
    });
  }

  setProvinces(data: any[]) {
    this.arrayFilterLocation = [];
    let provin: any[] = [];
    let cities: any[] = [];
    this.provinces = data;
    this.provinces.sort((a, b) => a.description.localeCompare(b.description));
    Object.assign(this.provincesOriginal, this.provinces);
    this.provinces.forEach((prov) => {
      provin.push(prov);
      prov.isChecked = false;
      prov.isColapsed = false;
      prov.propertyCount = 0;
      prov.locations.forEach((loc: any) => {
        cities.push(loc);
        loc.isChecked = false;
        loc.isColapsed = false;
        loc.propertyCount = 0;
        loc.addresses.forEach((address: any) => {
          prov.propertyCount += address.properties.length;
          loc.propertyCount += address.properties.length;
        });
      });
    });

    provin = provin.map((prov) => ({
      ...prov,
      description: prov.description + this.provincia,
    }));
    cities = cities.map((city) => ({
      ...city,
      description: city.description + this.ciudad,
    }));

    this.arrayFilterLocation = provin.concat(cities);
  }

  chooseFirstOption(): void {
    if (this.filter.length === 0) {
      this.propProvinceName = null;
      this.propLocationName = null;
      this.arrayLocationFilters = [];

      this.arrayLocationFilters.push({
        description: this.selectedLocation.value,
        description_eng: this.selectedLocation.value,
        type: 'location',
      });
      return;
    }
    this.matAutocomplete.options.first.select();
  }

  onSearchLocation(ubi: any) {
    const filter = ubi;
    this.selectedLocation.setValue(filter.description);
    this.arrayLocationFilters = [];

    this.arrayLocationFilters.push({
      description: this.selectedLocation.value,
      description_eng: this.selectedLocation.value,
      type: 'location',
    });

    this.provinces.forEach((element: any) => {
      element.isUnique = false;
      element.isSelected = false;
      if (filter?.id_province) {
        if (filter.id_province === element.id_province) {
          element.locations.forEach((loc: any) => {
            loc.isChecked = true;
            element.isUnique = true;
            this.selectedLocationResults = element.description;
          });
        } else {
          element.isUnique = false;
          element.isSelected = false;
          element.locations.forEach((loc: any) => {
            loc.isChecked = false;
          });
        }
      } else {
        element.locations.forEach((city: any) => {
          if (filter?.id_location === city.id_location) {
            element.isUnique = false;
            element.isSelected = true;
            this.selectedLocationResults = city.description;
            city.isChecked = true;
          } else {
            city.isChecked = false;
          }
        });
      }
    });
  }

  onchangePrecio(input: any, operacion: any) {
    let event = input.value;
    this.filtrado = true;
    event = event.replace('.', '');
    event = event.replace('€', '');
    event = event.replace('>', '');
    if (operacion === 'desde') {
      this.arrayPrecioDe.forEach((element: any) => {
        if (+element.value === +event) {
          this.minSelectedPrice = element.value;
          element.selected = true;
        } else {
          element.selected = false;
        }
      });
      this.arrayPrecioa.forEach((element: any) => {
        if (+element.value <= +event) {
          element.isDisabled = true;
        } else {
          element.isDisabled = false;
        }
      });
      this.minSelectedWidth = input?.selectedOptions[0]?.label.length || 0;
    } else {
      this.arrayPrecioa.forEach((element: any) => {
        if (+element.value === +event) {
          this.maxSelectedPrice = element.value;
          element.selected = true;
        } else {
          element.selected = false;
        }
      });
      this.arrayPrecioDe.forEach((element: any) => {
        if (+element.value > +event) {
          element.isDisabled = true;
        } else {
          element.isDisabled = false;
        }
      });
      this.maxSelectedWidth = input?.selectedOptions[0]?.label.length || 0;
    }
    this.filterPrice();
  }

  getWidth(from: string, type: string) {
    if (from === 'price') {
      let value = 0;
      if (type === 'min') {
        value = this.minSelectedWidth;
      } else {
        value = this.maxSelectedWidth;
      }
      if (value === 1) {
        return '30px';
      } else if (value <= 2) {
        return value * 15 + 10 + 'px';
      } else if (value === 3) {
        return type === 'min' ? '45px' : '50px';
      } else {
        return value * 10 + 12 + 'px';
      }
    } else {
      return this.minValueProfitabilityWidth * 20 + 12 + 'px';
    }
  }

  filterPrice() {
    this.priceFilters = [];
    this.pricefiltersString = '';
    this.priceFilterApplied =
      +this.minSelectedPrice !== this.minSelectedPriceDefault ||
      +this.maxSelectedPrice !== this.maxSelectedPriceDefault;
    if (this.priceFilterApplied) {
      this.pricefiltersString = this.minSelectedPrice?.toString();
      this.priceFilters.push(this.minSelectedPrice);
      if (+this.maxSelectedPrice !== +this.maxSelectedPriceDefault) {
        this.pricefiltersString =
          this.minSelectedPrice + '-' + this.maxSelectedPrice;
        this.priceFilters.push(this.maxSelectedPrice);
      }
    }
  }

  filterProfitability(input: any) {
    this.minValueProfitabilityWidth =
      input?.selectedOptions[0]?.label.length || 0;
    let item = input.value;
    this.ArrayProfitabilityFilters = [];
    this.profitabilityFilters = [];
    this.arrayRentabilidad.forEach((element) => {
      if (item === element.name) {
        element.selected = true;
        this.ArrayMoreFilters.push({
          description: 'Rentabilidad mayor a ' + element.value + '%',
          description_eng: 'Profitability higher than ' + element.value + '%',
          type: 'profitability',
        });
        this.profitabilityFilters.push(element.value);
        this.minValueProfitability = element.value;
      } else {
        element.selected = false;
      }
    });
  }

  public findPublication(): void {
    this.ArrayMoreFilters = [];
    this.propProvinceName = null;
    this.propLocationName = null;
    this.provinces.forEach((prov) => {
      if (prov?.isUnique) {
        this.propProvinceName = prov.description_filter
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        prov.locations.forEach((loc: any) => {
          this.locationIds.push(loc.id_location);
        });
      } else if (prov?.isSelected) {
        this.propProvinceName = prov.description_filter
          .normalize('NFD')
          .replace(/[\u0300-\u036f]/g, '');
        prov.locations.forEach((loc: any) => {
          if (loc.isChecked) {
            this.propLocationName = loc.description_filter
              .normalize('NFD')
              .replace(/[\u0300-\u036f]/g, '');
            this.locationIds.push(loc.id_location);
          }
        });
      }
    });

    let rangePrice = '';
    if (this.priceFilters.length) {
      rangePrice = this.priceFilters.join(',');
    }

    let filterSave = {
      loc: this.propLocationName ? this.propLocationName : null,
      prov: this.propProvinceName ? this.propProvinceName : null,
      rangoRentabilidad: this.profitabilityFilters.length
        ? this.profitabilityFilters.toString()
        : null,
      locationDescription: this.selectedLocation.value
        ? this.selectedLocation.value: null,
      rangoPrecio: this.priceFilters.length ? rangePrice : null,
      precio_minimo: this.priceFilters.length >= 1 ? this.priceFilters[0] : null,
      precio_maximo: this.priceFilters.length === 2 ? this.priceFilters[1] : null,
      ubicacion: this.locationIds.length > 0 ? this.locationIds.join(',') : '',
    };

    this.filterPropertiesDataService.buildQueryPublications(filterSave);
  }

  changeUrl(filters: any, filtersBar: any) {
    const params: any = {};
    Object.keys(filters).forEach((key) => {
      if (filters[key]) {
        Object.defineProperty(params, key, {
          enumerable: true,
          writable: true,
          configurable: true,
          value: filters[key],
        });
      }
    });

    const parametros =
      (filtersBar.tipoProp ? '/' + filtersBar.tipoProp : '') +
      (filtersBar.prov ? '/' + filtersBar.prov : '') +
      (filtersBar.loc ? '/' + filtersBar.loc : '');
    this.router.navigate(
      [this.translateService.currentLang + '/invertir' + parametros],
      {
        queryParams: params,
        replaceUrl: true,
      }
    );
  }

  private _filter(value: string): string[] {
    const filterValue = value
      .toLowerCase()
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '');
    this.filter = this.arrayFilterLocation.filter((option) =>
      option.description
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(filterValue)
    );
    return this.arrayFilterLocation.filter((option) =>
      option.description
        .toLowerCase()
        .normalize('NFD')
        .replace(/[\u0300-\u036f]/g, '')
        .includes(filterValue)
    );
  }
}
